module.exports = __webpack_public_path__ + "media/svgs/TAFA-Kurs-Anmeldung_Button-f0dd472bd8d3054ae249a3ac22da8c87.svg";